// Add your custom JS here.
import $ from 'jquery';

import AOS from 'aos';
import './custom/cmx';
import './custom/custom';
import './custom/sliders';

/*
import LocomotiveScroll from 'locomotive-scroll';

const locomotiveScroll = new LocomotiveScroll();


const scroller = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: true
});
*/


// Check if the .cards-stripe element exists on the page
if ($('.panel-advanced-stripe').length) {
  $(window).on('scroll', function() {
      // Get the offset of the .cards-stripe element from the top of the document
      var elementOffset = $('.panel-advanced-stripe').offset().top;
      
      // Get the current scroll position
      var scrollPosition = $(window).scrollTop();
      
      // Check if the scroll position has reached the element offset
      if (scrollPosition >= elementOffset) {
          console.log('You have scrolled to the .cards-stripe element!');
          
          // Optionally, remove the event listener
          $(window).off('scroll');
      }
  });

  window.onload = function() {
    var shadowRoot = document.querySelector('spline-viewer').shadowRoot;
    shadowRoot.querySelector('#logo').remove();
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    const unlimitedRight = document.querySelector('.unlimited-right');
    const unlimitedLeft = document.querySelector('.unlimited-left');
    const cardsRight = Array.from(document.querySelectorAll('.unlimited-right .cards'));
    const cardsLeft = Array.from(document.querySelectorAll('.unlimited-left .cards'));
    let scrollPosition = 0;
  
    // Function to shuffle an array (Fisher-Yates Shuffle)
    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
  
    function duplicateCards(container, cards, times) {
      for (let i = 0; i < times; i++) {
          cards.forEach(card => {
              const clone = card.cloneNode(true);
              container.appendChild(clone);
          });
      }
    }
  
    // Shuffle the left cards array
    shuffleArray(cardsLeft);
  
    // Duplicate cards enough times to fill the scrolling area
    const duplicationFactor = 5; // Increase or decrease based on your need
    duplicateCards(unlimitedRight, cardsRight, duplicationFactor);
    duplicateCards(unlimitedLeft, cardsLeft, duplicationFactor);
  
    function handleScroll() {
        const scrollY = window.scrollY;
        const scrollSpeed = 0.5;
  
        // Calculate the new scroll position
        scrollPosition = scrollY * scrollSpeed;
  
        // Apply the transform to move the containers
        unlimitedRight.style.transform = `translateX(${-scrollPosition}px) translateX(-50%)`;
        unlimitedLeft.style.transform = `translateX(${scrollPosition}px) translateX(-50%) rotateY(180deg)`;
  
        // Loop back to the start when reaching the end
        const rightWidth = unlimitedRight.scrollWidth / duplicationFactor;
        const leftWidth = unlimitedLeft.scrollWidth / duplicationFactor;
  
        if (scrollPosition >= rightWidth) {
            scrollPosition = 0;
            // window.scrollTo(0, 0);  // Reset the scroll position
        }
  
        if (scrollPosition >= leftWidth) {
            scrollPosition = 0;
            // window.scrollTo(0, 0);  // Reset the scroll position
        }
    }
  
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll); // Recalculate on resize
    handleScroll(); // Initial call to ensure proper placement
  });
  
}












$(document).ready(function() {

    // initialization of aos
    AOS.init( {
        duration: 1200,
        once: true,
    });
    
    function isElementInViewport($el) {
    var rect = $el[0].getBoundingClientRect();
    var margin = 100; // Margin in pixels
    return (
        rect.top + margin >= 0 &&
        rect.left + margin >= 0 &&
        rect.bottom - margin <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right - margin <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function animateCards() {
      $('.card-1').css({
          'opacity': 1,
          'transform': 'translate(calc(-50% - 94px), calc(-50% - 101px))'
      });

      $('.circle').css({
          'opacity': 1,

      });

      $('.card-2').css({
        'opacity': 1,
        'transform': 'translate(calc(50% + 115px), calc(-50% + 145px))'
    });
  }

  function checkVisibility() {
      $('.card-animation').each(function() {
          var $this = $(this);
          if (isElementInViewport($this)) {
              console.log('Element is in viewport');
              animateCards();
              $(window).off('scroll', checkVisibility); // Unbind scroll event once visible
          }
      });
  }

  $(window).on('scroll', checkVisibility);
  checkVisibility(); // Initial check
});


$(document).ready(function(){ 

  function movePill(button) {
    let pill = document.querySelector(".backgroundPill");
    let buttons = document.querySelectorAll(".mainSwitch button");

    if(button.value === "left") {
        pill.style.left = "5px";
        pill.innerHTML = buttons[0].innerHTML; // Set the pill text to match the left button
        document.querySelector(".switch-content.left").style.display = "block";
        document.querySelector(".switch-content.right").style.display = "none";
    } else {
        pill.style.left = "calc(50% + 5px)";
        pill.innerHTML = buttons[1].innerHTML; // Set the pill text to match the right button
        document.querySelector(".switch-content.left").style.display = "none";
        document.querySelector(".switch-content.right").style.display = "block";
    }
}


  // Initialize the first content section in each switch-content to fade in on page load
  $(".switch-content").each(function() {
    $(this).find(".content-section:visible").fadeIn(200);
});

$(".menu li").on("click", function() {
    var target = $(this).data("target");
    var $switchContent = $(this).closest(".switch-content");

    // Hide all content sections within the current switch-content with fade out
    $switchContent.find(".content-section:visible").fadeOut(200, function() {
        // Show the selected content section with fade in after the previous one is hidden
        $("#" + target).fadeIn(200);
    });

    // Remove active class from all menu items within the current switch-content
    $switchContent.find(".menu li").removeClass("active");

    // Add active class to the clicked menu item
    $(this).addClass("active");
});

// Pill switch logic
function movePill(a){
    let pill = document.querySelector(".backgroundPill");
    if(a.value == "left"){
        pill.style.left = "5px";
        $(".switch-content.left").show();
        $(".switch-content.right").hide();
    } else {
        pill.style.left = "48%";
        $(".switch-content.left").hide();
        $(".switch-content.right").show();
    }
}

$(".mainSwitch button").on("click", function() {
    movePill(this);
});

// Initial state: Show left content and hide right content
$(".switch-content.left").show();
$(".switch-content.right").hide();

  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $(".navbar").addClass("scrolled");
    } else {
        $(".navbar").removeClass("scrolled");
    }
  });

  //Click event to scroll to topxx
  $('.scroll-to-top').click(function(){
    $('html, body').animate({scrollTop : 0},800);
    return false;
  });


  //CMX Stripe Colour 
  $('.click-cmx').click(function(){
    location.href = "?cmx=1";
    return false;
  });

  if(window.location.href.indexOf("?cmx=1") != -1){
    $('.click-cmx').addClass( "d-none" );
  }

  //Check to see if the window is top if not then display button
  $(window).scroll(function(){
  if ($(this).scrollTop() > 500) {
      $('.scroll-to-top').fadeIn();
  } else {
      $('.scroll-to-top').fadeOut();
  }
  });

  //console.log('test1');
  $(".navbar-toggler").on("click", function(e){
    $(this).toggleClass("opened");
    $("body").css('padding-right', '0');
  });

  $(".offcanvas-backdrop").on("click", function(e){
    $(".navbar-toggler").removeClass("opened");
    $("body").css('padding-right', '0');
  });

  $( '.sub-menu-toggle' ).on( 'click', function() {
      $(this).toggleClass( 'show' );
      $(this).parent().find('.dropdown-menu').first().slideToggle();
  })
      
  $('a.nav-link.dropdown-toggle').click(function() {
      location.href = this.href;
  });

});



var myOffcanvas = document.getElementById('navbarNavOffcanvas')
myOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
  var navbar = document.querySelector('.navbar-toggler');
  navbar.classList.remove("opened") 
})
